import { render, staticRenderFns } from "./symptomSurveyRoutineDetail.vue?vue&type=template&id=9b0b337a"
import script from "./symptomSurveyRoutineDetail.vue?vue&type=script&lang=js"
export * from "./symptomSurveyRoutineDetail.vue?vue&type=script&lang=js"
import style0 from "./symptomSurveyRoutineDetail.vue?vue&type=style&index=0&id=9b0b337a&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9b0b337a')) {
      api.createRecord('9b0b337a', component.options)
    } else {
      api.reload('9b0b337a', component.options)
    }
    module.hot.accept("./symptomSurveyRoutineDetail.vue?vue&type=template&id=9b0b337a", function () {
      api.rerender('9b0b337a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/hea/mss/symptomSurveyRoutineDetail.vue"
export default component.exports